import { render, staticRenderFns } from "./AddNewsToHome.vue?vue&type=template&id=171d486e&scoped=true&"
import script from "./AddNewsToHome.vue?vue&type=script&lang=js&"
export * from "./AddNewsToHome.vue?vue&type=script&lang=js&"
import style0 from "./AddNewsToHome.vue?vue&type=style&index=0&id=171d486e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171d486e",
  null
  
)

export default component.exports